import { makeStyles } from '@mui/styles'

const useStyle = makeStyles(() => ({
  rowChecked: {
    borderRadius: 8,
    cursor: 'pointer',
    backgroundColor: '#ececec',
    '& #kebab': {
      color: '#263057'
    }
  },
  row: {
    borderRadius: 8,
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: '#ececec',
      '& #kebab': {
        color: '#263057'
      }
    }
  },
  itemCheck: {
    height: 44,
    fontFamily: 'Roboto',
    fontWeight: 'bold',
    color: '#6e7a76',
    width: '5%',
    borderTopLeftRadius: 8,
    borderBottomLeftRadius: 8,
    textAlign: 'center'
  },

  itemIcon: {
    height: 44,
    width: '5%',
    color: '#6e7a76',
    textAlign: 'center',
    '&:hover': {
      color: '#026873'
    }
  },
  hoverButton: {
    color: '#706E6F',
    '&:hover': {
      color: '#026873'
    }
  },
  hoverButtonDelete: {
    color: '#706E6F',
    '&:hover': {
      color: '#AD0707'
    }
  },

  organizationName: {
    height: 44,
    fontFamily: 'Roboto',
    fontSize: 14,
    fontWeight: 'bold',
    color: '#6e7a76',
    textAlign: 'center',
    '&:hover': {
      backgroundColor: '#ececec'
    },
    textOverflow: 'ellipsis',
    width: '20%',
    overflow: 'hidden',
    whiteSpace: 'nowrap'
  },
  cuit: {
    height: 44,
    fontFamily: 'Roboto',
    fontSize: 14,
    fontWeight: 'bold',
    color: '#6e7a76',
    textAlign: 'center',
    '&:hover': {
      backgroundColor: '#ececec'
    },
    textOverflow: 'ellipsis',
    width: '10%',
    overflow: 'hidden',
    whiteSpace: 'nowrap'
  },
  date: {
    height: 44,
    fontFamily: 'Roboto',
    fontSize: 14,
    fontWeight: 'bold',
    color: '#6e7a76',
    textAlign: 'center',
    '&:hover': {
      backgroundColor: '#ececec'
    },
    textOverflow: 'ellipsis',
    width: '25%',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    '@media all and (max-width: 450px)': {
      display: 'none'
    }
  },
  numberOfModules: {
    height: 44,
    fontFamily: 'Roboto',
    fontSize: 14,
    fontWeight: 'bold',
    color: '#6e7a76',
    textAlign: 'center',
    '&:hover': {
      backgroundColor: '#ececec'
    },
    textOverflow: 'ellipsis',
    width: '20%',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    '@media all and (max-width: 450px)': {
      display: 'none'
    }
  },
  numberOfActiveUser: {
    height: 44,
    fontFamily: 'Roboto',
    fontSize: 14,
    fontWeight: 'bold',
    color: '#6e7a76',
    textAlign: 'center',
    width: '20%',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    '&:hover': {
      backgroundColor: '#ececec'
    },
    '@media all and (max-width: 450px)': {
      display: 'none'
    }
  },

  numberOfDerivedUser: {
    height: 44,
    fontFamily: 'Roboto',
    fontSize: 14,
    fontWeight: 'bold',
    color: '#6e7a76',
    textAlign: 'center',
    width: '20%',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    '&:hover': {
      backgroundColor: '#ececec'
    },
    '@media all and (max-width: 450px)': {
      display: 'none'
    }
  },
  appCode: {
    height: 44,
    fontFamily: 'Roboto',
    fontSize: 14,
    fontWeight: 'bold',
    color: '#6e7a76',
    width: '20%',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textAlign: 'center',
    '&:hover': {
      backgroundColor: '#ececec'
    },
    '@media all and (max-width: 450px)': {
      display: 'none'
    }
  },

  itemKebab: {
    height: 44,
    fontFamily: 'Roboto',
    fontWeight: 'bold',
    color: '#2C3532',
    width: '5%',
    textAlign: 'start',
    borderTopRightRadius: 8,
    borderBottomRightRadius: 8,
    '&:hover': {
      backgroundColor: '#ececec'
    }
  },
  kebab: {
    color: '#B3B3B3'
  }
}))

export default useStyle
